import React, { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { SlProgressBar } from "@shoelace-style/shoelace/dist/react";
import api from "../../services/api";
import { Toast } from "../../shared/Toast";
import { useNavigate } from "react-router";
import { CreativeContext } from "./CreativeCreation";

function FullVideo({
  handleshow,
  // advId,
  creative_name,
  creative_type,
  subtype,
  editdata,
  company,
  companyName,
  flag,
  handlesubmit,
  createdEdited,
}) {
  const { preview, setPreview } = useContext(CreativeContext);
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [vidProgress, setVidProgress] = useState(0);
  const [imgurl, setImgurl] = useState("");
  const [videourl, setVideourl] = useState("");
  const [image, setImage] = useState("");
  const [video, setVideo] = useState("");
  const [sub, setSub] = useState(true);

  const langauges = [
    "",
    "Telugu",
    "Tamil",
    "Hindi",
    "Kannada",
    "Malayalam",
    "Marathi",
    "Bengali",
    "Gujarati",
    "Punjabi",
    "Odia",
    "English",
    "",
    "Telugu-English",
  ];
  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (
        e.target.files[0].type === "image/jpg" ||
        e.target.files[0].type === "image/jpeg" ||
        e.target.files[0].type === "image/webp" ||
        e.target.files[0].type === "image/png"
      ) {
        setImage(e.target.files[0]);
      } else {
        Toast("error", "Only jpg, jpeg, webp, png formats accepted");
        setValue("image", "");
      }
    } else {
      if (flag === "edit") {
        setImgurl(editdata.img_urls);
        setPreview({ ...preview, img_urls: editdata.img_urls });
      } else {
        setProgress(0);
        setImgurl("");
        setPreview({ ...preview, img_urls: "" });
      }
    }
  };
  const videoChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      if (e.target.files[0].size < 26214400) {
        setVideo(e.target.files[0]);
      } else {
        Toast("error", "Video size must be less than 25mb");
        setValue("video", "");
      }
    } else {
      if (flag === "edit") {
        setVideourl(editdata.video_urls);
        setPreview({ ...preview, video_urls: editdata.video_urls });
      } else {
        setVidProgress(0);
        setVideourl("");
        setPreview({ ...preview, video_urls: "" });
      }
    }
  };

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });

  const formData1 = new FormData();
  formData1.append("files", image);
  const imageUrl = async () => {
    try {
      let url = await api({
        url: `/upload/image`,
        method: "POST",
        responseType: "json",
        data: formData1,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) => {
          setProgress(Math.round((100 * data.loaded) / data.total));
        },
      });
      if (url.code === 200) {
        setImgurl(url.data.data);
        setPreview({ ...preview, img_urls: url.data.data });
      } else {
        setProgress(0);
        setValue("image", null);
        setImage("");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  };
  const formData = new FormData();
  formData.append("files", video);
  const videoUrl = async () => {
    try {
      let url = await api({
        url: `/upload/video`,
        method: "POST",
        responseType: "json",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (data) => {
          setVidProgress(Math.round((100 * data.loaded) / data.total));
        },
      });
      if (url.code === 200) {
        setVideourl(url.data.data);
        setPreview({
          ...preview,
          video_urls: url.data.data,
        });
        setValue("videolink", "");
      } else {
        setVidProgress(0);
        setValue("video", "");
        setVideo("");
        Toast("error", url.data.message);
      }
    } catch (error) {
      Toast("error", error);
    }
  };

  useEffect(() => {
    if (image) imageUrl();
  }, [image]);

  useEffect(() => {
    if (video) videoUrl();
  }, [video]);

  let watchcheck = watch("btnclick");
  if (flag === "edit")
    watchcheck = watch(
      "btnclick",
      editdata.button_enabled === 1 ? true : false
    );
  let watchMute = watch("mute");
  if (flag === "edit") {
    watchMute = watch("mute", editdata?.unmute === 1 ? true : false);
  }

  let watchPlay = watch("playicon");
  let watchloop = watch("loop");
  let watchMuteIcon = watch("enableMuteIcon", true);
  let watchIsIma = watch('is_ima')
  let watchIsImaObs = watch('is_ima_obs')
  let watchVolume = watch('volume', 50)
  if (flag === "edit") {
    try {
      if (editdata.video_controls) {
        watchPlay = watch(
          "playicon",
          editdata.video_controls.playicon === 1 ? true : false
        );
        watchloop = watch(
          "loop",
          editdata.video_controls.loop === 1 ? true : false
        );
        watchMuteIcon = watch(
          "enableMuteIcon",
          editdata?.video_controls.enableMuteIcon === 1 ? true : false
        );
        watchVolume = watch('volume', editdata?.video_controls?.volume === undefined ?  50 : editdata?.video_controls.volume)
        watchIsIma = watch('is_ima',editdata?.video_controls.is_ima === 1 ? true : false);
        watchIsImaObs = watch('is_ima_obs', editdata?.video_controls.is_ima_obs === 1 ? true : false);
      }
    } catch (error) {
      // Handle the expected error here, or log it for debugging
      watchPlay = watch("playicon", false);
      watchloop = watch("loop", false);
      console.error("Expected error:", error);
    }
  }
  useEffect(() => {
    if (watchcheck !== false) {
      setPreview({ ...preview, button_enabled: watchcheck, position: "Top" });
    } else {
      setPreview({ ...preview, button_enabled: false, position: "" });
    }
  }, [watchcheck]);

  let watchposition = watch("position");
  useEffect(() => {
    if (watchposition !== "Top") {
      setPreview({ ...preview, position: watchposition });
    } else {
      setPreview({ ...preview, position: "Top" });
    }
  }, [watchposition]);

  let watchbtntext = watch("btntext");
  useEffect(() => {
    if (watchbtntext !== "") {
      setPreview({ ...preview, button_text: watchbtntext });
    } else {
      setPreview({ ...preview, button_text: "" });
    }
  }, [watchbtntext]);

  let watchbtnurl = watch("btnurl", false);
  useEffect(() => {
    if (watchbtnurl !== "") {
      setPreview({ ...preview, button_link: watchbtnurl });
    } else {
      setPreview({ ...preview, button_link: "" });
    }
  }, [watchbtnurl]);

  let watchbuttonLang = watch("buttonLang", false);
  useEffect(() => {
    setPreview({ ...preview, btn_text_lang: watchbuttonLang });
  }, [watchbuttonLang]);

  let watchbtntextclr = watch("btntextclr");
  useEffect(() => {
    if (watchbtntextclr !== "") {
      setPreview({
        ...preview,
        button_enabled: watchcheck,
        button_link: watchbtnurl,
        button_text: watchbtntext,
        btn_text_lang: watchbuttonLang,
        btn_text_clr: watchbtntextclr,
        btn_text_bgclr: watchbtntextbgclr,
      });
    } else {
      setPreview({
        ...preview,
        button_enabled: watchcheck,
        button_link: watchbtnurl,
        button_text: watchbtntext,
        btn_text_lang: watchbuttonLang,
        btn_text_clr: "",
        btn_text_bgclr: watchbtntextbgclr,
      });
    }
  }, [watchbtntextclr]);

  let watchbtntextbgclr = watch("btntextbgclr");
  useEffect(() => {
    if (watchbtntextbgclr !== "") {
      setPreview({
        ...preview,
        button_enabled: watchcheck,
        button_link: watchbtnurl,
        button_text: watchbtntext,
        btn_text_lang: watchbuttonLang,
        btn_text_clr: watchbtntextclr,
        btn_text_bgclr: watchbtntextbgclr,
      });
    } else {
      setPreview({
        ...preview,
        button_enabled: watchcheck,
        button_link: watchbtnurl,
        button_text: watchbtntext,
        btn_text_lang: watchbuttonLang,
        btn_text_clr: watchbtntextclr,
        btn_text_bgclr: "",
      });
    }
  }, [watchbtntextbgclr]);

  let watchvideolink = watch("videolink", "");
  useEffect(() => {
    if (watchvideolink !== "") {
      setPreview({ ...preview, video_urls: watchvideolink });
      setValue("video", "");
      setVideourl("");
    } else {
      if (flag === "edit") {
        setPreview({ ...preview, video_urls: editdata.video_urls });
      } else {
        setPreview({ ...preview, video_urls: videourl });
      }
    }
  }, [watchvideolink]);

  useEffect(() => {
    if (flag === "edit") {
      setPreview({
        ...preview,
        sub_type: editdata.sub_type,
        img_urls: editdata.img_urls,
        video_urls: editdata.video_urls,
        position: editdata.position === 0 ? "Top" : "Bottom",
        button_enabled: editdata.button_enabled === 1 ? true : false,
        button_text: editdata.button_text,
        button_link: editdata.button_link,
        btn_text_lang: editdata.btn_text_lang,
        btn_text_clr: editdata.btn_text_clr,
        btn_text_bgclr: editdata.btn_text_bgclr,
      });
    }
  }, [company]);

  const onSubmit = async (data) => {
    if (flag === "add") {
      handlesubmit(true);
      let obj = {
        company_id: company,
        company_name: companyName,
        // adv_id: advId,
        creative_name,
        creative_type,
        sub_type: subtype,
        img_url: imgurl,
        video_url: videourl ? videourl : data.videolink,
        clickurl: data.clickurl,
        impurl: { primary: data.impurl, secondary: data.impurl1 },
        btnclick: watchcheck,
        btntext: data.btntext,
        btnurl: data.btnurl,
        position: data.position,
        btn_text_lang: parseInt(data.buttonLang),
        btn_text_clr: data.btntextclr,
        btn_text_bgclr: data.btntextbgclr,
        mute: data.mute,
        enableMuteIcon: data.enableMuteIcon,
        playicon: data.playicon,
        loop: data.loop,
        is_ima:data.is_ima,
        is_ima_obs:data.is_ima_obs,
        volume:data.mute ? data.volume : 0

      };
      // if (advId !== "" && creative_name !== "") {
      if (creative_name !== "") {
        try {
          let res = await api({
            url: `/creatives/video/fullvideo`,
            method: "POST",
            responseType: "json",
            data: obj,
          });
          if (res?.code === 200) {
            Toast("success", " Creative Created Successfully  ");
            handleshow(false);
            createdEdited(true);
          } else {
            Toast("error", res.data.message);
          }
        } catch (error) {
          console.log(error);
          if (error.response.status === 401) navigate("/");
        }
      }
    } else if (flag === "edit") {
      let obj = {
        creative_name: creative_name,
        creative_id: editdata.creative_id,
        // clickurl: data.clickurl,
        mute: data.mute,
        volume:data.mute ? data.volume : 0,
        enableMuteIcon: data.enableMuteIcon,
        playicon: data.playicon,
        loop: data.loop,
        impurl: { primary: data.impurl, secondary: data.impurl1 },
        is_ima:data.is_ima,
        is_ima_obs:data.is_ima_obs

      };
      image !== "" ? (obj.img_url = imgurl) : (obj.img_url = editdata.img_urls);
      data.videolink !== ""
        ? (obj.video_url = data.videolink)
        : (obj.video_url = videourl ? videourl : editdata.video_urls);
      watchcheck === true ? (obj.btnclick = true) : (obj.btnclick = false);
obj.clickurl = data.clickurl
      watchcheck === true ? (obj.btntext = data.btntext) : (obj.btntext = "");
      watchcheck === true ? (obj.btnurl = data.btnurl) : (obj.btnurl = "");
      watchcheck === true
        ? (obj.btn_text_clr = data.btntextclr)
        : (obj.btn_text_clr = "");
      watchcheck === true
        ? (obj.btn_text_bgclr = data.btntextbgclr)
        : (obj.btn_text_bgclr = "");
      watchcheck === true
        ? (obj.btn_text_lang = parseInt(watchbuttonLang))
        : (obj.btn_text_lang = null);
      try {
        let res = await api({
          url: `/creatives/video/editfullvideo`,
          method: "POST",
          responseType: "json",
          data: obj,
        });
        if (res?.code === 200) {
          Toast("success", " Creative Edited Successfully  ");
          createdEdited(true);
          handleshow(false);
        } else {
          Toast("error", res.data.message);
        }
      } catch (error) {
        console.log(error);
        if (error.response.status === 401) navigate("/");
      }
    }
  };

  return (
    <div className="row">
      <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
        <section className="col-12">
          <div className="form-group">
            <div className="mb-3">
              <label className="form-label">Upload video</label>
              <br />
              <span>
                (Video duration must be below 1-min and size must be less than
                25mb )
              </span>
              <input
                className="form-control mb-2"
                type="file"
                id="formFile"
                name="files"
                {...register("video", {
                  required:
                    flag === "edit"
                      ? false
                      : watchvideolink === ""
                      ? true
                      : false,
                  onChange: (e) => videoChange(e),
                })}
              />
              {errors.video && (
                <p className="text-red-600">Video is mandatory</p>
              )}
              {vidProgress > 0 && vidProgress < 100 ? (
                <SlProgressBar value={vidProgress}>
                  {vidProgress}%
                </SlProgressBar>
              ) : videourl !== "" ? (
                <span className="text-wrap">{`${videourl}`}</span>
              ) : (
                flag === "edit" && <span className="text-wrap">{`${editdata.video_urls}`}</span>
              )}
            </div>
            <div className="flex gap-1">
            <div className="mb-3 w-10/12">
              <label className="form-label">Video URL</label>
              <input
                className="form-control"
                type="text"
                {...register("videolink", {
                  required: false,
                  pattern: {
                    value:
                      /^(https:\/\/(?:www\.)?(?:youtube\.com\/embed\/\S+|\S+\.mp4|\S+))$/,
                    message: "Enter a Valid .mp4 URL",
                  },
                })}
              />
              {(watchvideolink.includes("youtube.com/") ||
                watchvideolink.includes("youtu.be/")) &&
              !watchvideolink.includes("/embed/") ? (
                <p className="text-red-600">Enter a Valid Embed URL</p>
              ) : (
                errors.videolink && (
                  <p className="text-red-600">{errors.videolink.message}</p>
                )
              )}
            </div>
            <div className="form-check form-check-inline">
            <label htmlFor="isima" className="form-label">Is IMA</label>
            <input
                className="form-check-input"
                type="checkbox"
                id="isima"
                checked={watchIsIma}
                {...register("is_ima", {
                  required: false,
                })}
              />
            </div>
            {watchIsIma ? <div className="form-check form-check-inline">
            <label htmlFor="isima_obs" className="form-label">Is IMA Obstacle</label>
            <input
                className="form-check-input"
                type="checkbox"
                id="isima_obs"
                checked={watchIsImaObs}
                {...register("is_ima_obs", {
                  required: false,
                })}
              />
            </div> : null}
            </div>
            
            
            <div className="mb-3">
              <label className="form-label">Thumbnail Image</label>
              <br />
              <span>(Image height should be greater than width )</span>
              <input
                className="form-control mb-2"
                type="file"
                id="formFile"
                name="files"
                {...register("image", {
                  required: flag === "edit" ? false : true,
                  onChange: (e) => imageChange(e),
                })}
              />
              {errors.image && (
                <p className="text-red-600">Image is mandatory</p>
              )}
              {progress > 0 && progress < 100 ? (
                <SlProgressBar value={progress}>{progress}%</SlProgressBar>
              ) : imgurl !== "" ? (
                <span>{`${imgurl}`}</span>
              ) : (
                flag === "edit" && <span>{` ${editdata.img_urls}`}</span>
              )}
            </div>
            <div className="row mb-3">
              <div className="col">
                <label className="form-label">Impression URL</label>
                <input
                  type="text"
                  className="form-control"
                  name="impurl"
                  defaultValue={
                    editdata.impression_tracking_url
                      ? editdata.impression_tracking_url.primary
                      : null
                  }
                  {...register("impurl", {
                    required: false,
                    pattern: {
                      value:
                        /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                      message: "Enter a Valid URL",
                    },
                  })}
                />
                {errors.impurl && (
                  <p className="text-red-600">{errors.impurl.message}</p>
                )}
              </div>
              <div className="col">
                <label className="form-label">Impression URL - Secondary</label>
                <input
                  type="text"
                  className="form-control"
                  defaultValue={
                    editdata.impression_tracking_url
                      ? editdata.impression_tracking_url.secondary
                      : null
                  }
                  {...register("impurl1", {
                    required: false,
                    pattern: {
                      value:
                        /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/,
                      message: "Enter a Valid URL",
                    },
                  })}
                />
                {errors.impurl1 && (
                  <p className="text-red-600">{errors.impurl1.message}</p>
                )}
              </div>
            </div>
            <div className="col">
                    <label className="form-label">Click URL</label>
                    <input
                      id="url"
                      className="form-control"
                      name="clickurl"
                      defaultValue={editdata.click_url}
                      {...register("clickurl", {
                        required: false,
                        pattern: {
                          value:
                        /^((https?|ftp):\/\/[^\s\/$.?#].[^\s]*)$|^(www\.[^\s\/$.?#].[^\s]*)$|^([6-9]\d{9})$|^(0[6-9]\d{9})$/,
                          message: "Enter a Valid URL or Mobile Number",
                        },
                      })}
                    />
                    {errors.clickurl && (
                      <p className="text-red-600">{errors.clickurl.message}</p>
                    )}
                  </div>

            <section>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={watchcheck}
                  {...register("btnclick", { required: false })}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Enable Button Click
                </label>
              </div>
              {watchcheck && (
                <>
                
                  <div>
                    (Button text Color and Back Ground color is mandatory)
                  </div>
                  <div className="row mb-4">
                    <div className="col">
                      <label htmlFor="" className="form-label">
                        Button Text
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={editdata.button_text}
                        {...register("btntext", { required: watchcheck })}
                      />
                      {errors.btntext && (
                        <p className="text-red-600">Button Text is mandatory</p>
                      )}
                    </div>
                    <div className="col">
                      <label htmlFor="" className="form-label">
                        Button Text color
                      </label>
                      <input
                        type="color"
                        required={true}
                        defaultValue={
                          flag === "edit" ? editdata.btn_text_clr : "#000000"
                        }
                        {...register("btntextclr", {
                          required: watchcheck,
                          pattern: {
                            value: /^#(?!000000)[a-zA-z0-9]{6}/gm,
                          },
                        })}
                      />

                      {errors.btntextclr && (
                        <p className="text-red-600">
                          Button Text color is mandatory
                        </p>
                      )}
                    </div>
                    <div className="col">
                      <label htmlFor="" className="form-label">
                        Button Text background color
                      </label>
                      <input
                        type="color"
                        defaultValue={
                          flag === "edit" ? editdata.btn_text_bgclr : "#ffffff"
                        }
                        {...register("btntextbgclr", {
                          required: watchcheck,
                          pattern: {
                            value: /^#(?!ffffff)[a-zA-z0-9]{6}/gm,
                          },
                        })}
                      />
                      {errors.btntextbgclr && (
                        <p className="text-red-600">
                          Button Text background color is mandatory
                        </p>
                      )}
                    </div>
                    <div className="col">
                      <label htmlFor="" className="form-label">
                        Button Link
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        defaultValue={editdata.button_link}
                        {...register("btnurl", {
                          required: watchcheck,
                          pattern: {
                            value:
                        /^((https?|ftp):\/\/[^\s\/$.?#].[^\s]*)$|^(www\.[^\s\/$.?#].[^\s]*)$|^([6-9]\d{9})$|^(0[6-9]\d{9})$/,
                            message: "Enter a Valid URL or Mobile Number",
                          },
                        })}
                      />
                      {errors.btnurl?.type === "pattern" && (
                        <p className="text-red-600">{errors.btnurl.message}</p>
                      )}
                      {errors.btnurl
                        ? errors.btnurl?.type !== "pattern" && (
                            <p className="text-red-600">
                              {"Button URL Mandatory"}
                            </p>
                          )
                        : null}
                    </div>
                  </div>
                  <div className="row">
                    {/* <div className="col">
                    <label className="form-label">Position</label>
                    <select
                      className="form-select"
                      type="text"
                      defaultValue={
                        flag === "edit"
                          ? editdata.position === 0
                            ? "Top"
                            : "Bottom"
                          : "Top"
                      }
                      {...register("position", { required: true })}
                    >
                      <option defaultValue="Top">Top</option>
                      <option value="Bottom">Bottom</option>
                    </select>
                  </div> */}
                    <div className="col">
                      <label className="form-label">Button Language</label>
                      <select
                        className="form-select"
                        type="text"
                        defaultValue={
                          flag === "edit"
                            ? editdata.btn_text_lang !== null
                              ? `${editdata.btn_text_lang}`
                              : "1"
                            : "1"
                        }
                        {...register("buttonLang", { required: true })}
                      >
                        <option value="1">Telugu</option>
                        <option value="7">Bengali</option>
                        <option value="3">Hindi</option>
                        <option value="6">Marathi</option>
                        <option value="2">Tamil</option>
                        <option value="4">Kannada</option>
                        <option value="5">Malayalam</option>
                        <option value="8">Gujarathi</option>
                        <option value="10">Oria</option>
                        <option value="11">English</option>
                        <option value="13">Telugu-English</option>
                      </select>
                    </div>
                  </div>
                </>
              )}
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={watchMuteIcon}
                  {...register("enableMuteIcon", { required: false })}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Enable Mute icon
                </label>
              </div>
             
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={watchMute}
                    {...register("mute", { required: false })}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexCheckDefault"
                  >
                    Unmute
                  </label>
                </div>

                {watchMute ? <div className="mb-3">
                    <label
                    className="form-label"
                  >
                    {`Volume: ${watchVolume} %`}
                  </label>
                  <br/>
                    <input type="range" min={0} max={100} defaultValue={editdata?.video_controls?.volume ? editdata?.video_controls?.volume : watchVolume}  {...register("volume", { required: watchMute })} />
                    
                </div> : null}
            
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={watchPlay}
                  {...register("playicon", { required: false })}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                 Enable Play Icon
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={watchloop}
                  {...register("loop", { required: false })}
                />
                <label className="form-check-label" htmlFor="flexCheckDefault">
                  Loop
                </label>
              </div>
            </section>
            <div className="my-3 text-end">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={
                  (progress > 0 && progress < 100) ||
                  (vidProgress > 0 && vidProgress < 100)
                }
              >
                Save Creative
              </button>
            </div>
          </div>
        </section>
      </form>
    </div>
  );
}
export default FullVideo;
